export const alabama = {
  "01000": "Alabama",
  "01001": "Autauga County",
  "01003": "Baldwin County",
  "01005": "Barbour County",
  "01007": "Bibb County",
  "01009": "Blount County",
  "01011": "Bullock County",
  "01013": "Butler County",
  "01015": "Calhoun County",
  "01017": "Chambers County",
  "01019": "Cherokee County",
  "01021": "Chilton County",
  "01023": "Choctaw County",
  "01025": "Clarke County",
  "01027": "Clay County",
  "01029": "Cleburne County",
  "01031": "Coffee County",
  "01033": "Colbert County",
  "01035": "Conecuh County",
  "01037": "Coosa County",
  "01039": "Covington County",
  "01041": "Crenshaw County",
  "01043": "Cullman County",
  "01045": "Dale County",
  "01047": "Dallas County",
  "01049": "DeKalb County",
  "01051": "Elmore County",
  "01053": "Escambia County",
  "01055": "Etowah County",
  "01057": "Fayette County",
  "01059": "Franklin County",
  "01061": "Geneva County",
  "01063": "Greene County",
  "01065": "Hale County",
  "01067": "Henry County",
  "01069": "Houston County",
  "01071": "Jackson County",
  "01073": "Jefferson County",
  "01075": "Lamar County",
  "01077": "Lauderdale County",
  "01079": "Lawrence County",
  "01081": "Lee County",
  "01083": "Limestone County",
  "01085": "Lowndes County",
  "01087": "Macon County",
  "01089": "Madison County",
  "01091": "Marengo County",
  "01093": "Marion County",
  "01095": "Marshall County",
  "01097": "Mobile County",
  "01099": "Monroe County",
  "01101": "Montgomery County",
  "01103": "Morgan County",
  "01105": "Perry County",
  "01107": "Pickens County",
  "01109": "Pike County",
  "01111": "Randolph County",
  "01113": "Russell County",
  "01115": "St. Clair County",
  "01117": "Shelby County",
  "01119": "Sumter County",
  "01121": "Talladega County",
  "01123": "Tallapoosa County",
  "01125": "Tuscaloosa County",
  "01127": "Walker County",
  "01129": "Washington County",
  "01131": "Wilcox County",
  "01133": "Winston County",
};
